import { type RefObject, useEffect } from "react";

// Marks the tag whose page is open (aria-current), including in answers that
// arrive later: the thread's HTML is the server's, so this watches it while a
// page is open, at most once a frame.
export const useActivePageTag = (
  ref: RefObject<HTMLElement | null>,
  activeHref: string | null,
) => {
  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const apply = () => {
      element.querySelectorAll("a.pt").forEach((tag) => {
        if (tag.getAttribute("href") === activeHref) {
          tag.setAttribute("aria-current", "page");
        } else {
          tag.removeAttribute("aria-current");
        }
      });
    };
    apply();
    if (!activeHref) return;

    let frame = 0;
    const observer = new MutationObserver(() => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        apply();
      });
    });
    observer.observe(element, { childList: true, subtree: true });
    return () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
    };
  }, [ref, activeHref]);
};
